import {Platform} from 'react-native';
import {
  getBuildNumber,
  getDeviceId,
  getReadableVersion,
  getSystemVersion,
} from 'react-native-device-info';
import {flow, toInteger} from 'lodash/fp';

import PlatformConfig from '/config/platform.config';

import pkg from './../../package.json';

export function getAppVersion() {
  if (Platform.OS === 'web') {
    return pkg.version;
  }
  return getReadableVersion();
}

export function getDeviceType() {
  return getDeviceId();
}

export function getDeviceOsVersion() {
  let osName = PlatformConfig.getOS();
  let osVersion = getSystemVersion();
  return `${osName}: ${osVersion}`;
}

export const getAppBuildNumber = flow(getBuildNumber, toInteger);
